import { isBlockEditor } from 'utils/editor-context';

const DURATION = 2000;
const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

// Whether to group is decided by the TARGET (from 5 digits: "12 000", while "1993" stays
// a year), so intermediate values keep the same shape and the width does not jump.
const shouldGroup = (target, group) => group && String(Math.abs(target)).length > 4;

const format = (value, grouped) => {
    const text = String(Math.round(value));
    return grouped ? text.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') : text;
};

const count = (counter) => {
    const target = parseInt(counter.dataset.number, 10) || 0;
    const group = shouldGroup(target, counter.dataset.group === '1');
    const start = performance.now();

    const step = (now) => {
        const t = Math.min(1, (now - start) / DURATION);
        counter.textContent = format(target * easeOutCubic(t), group);
        if (t < 1) window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
};

const animatedNumberInit = (block) => {
    const counters = block
        ? Array.from(block[0].querySelectorAll('.bn-animated-number__number'))
        : Array.from(document.querySelectorAll('.bn-animated-number__number'));

    // The server renders the final value; keep it when motion is reduced.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    counters.forEach((counter) => {
        counter.textContent = '0';

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                count(counter);
                observer.disconnect();
            }
        });
        observer.observe(counter);
    });
};

document.addEventListener('DOMContentLoaded', function () {
    if (!isBlockEditor()) {
        animatedNumberInit();
    } else if (window.acf) {
        window.acf.addAction('render_block_preview/type=bn/animated-number', animatedNumberInit);
    }
});
